import { BrowserRouter, useRoutes } from "react-router-dom";

import { printRoutes } from "./print.routes";

function InnerPrintRouter() {
  return useRoutes(printRoutes);
}

export function PrintRouter() {
  return (
    <BrowserRouter>
      <InnerPrintRouter />
    </BrowserRouter>
  );
}
